var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutBgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 409,
    viewBox: "0 0 390 409",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.97 338.399C183.81 352.209 187.516 370.316 182.972 387.274L160.717 470.332C159.528 474.77 153.782 475.947 150.943 472.334L0.184583 280.46C-10.6677 266.648 -14.3796 248.531 -9.83334 231.564L12.4591 148.367C13.6487 143.928 19.3961 142.752 22.2341 146.367L172.97 338.399Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.398 531.233C148.942 514.275 145.237 496.168 134.397 482.358L-16.3396 290.326C-19.1775 286.71 -24.925 287.887 -26.1146 292.326L-46.9313 370.015C-51.4789 386.987 -47.7636 405.109 -36.9048 418.922L113.866 610.713C116.705 614.325 122.45 613.148 123.639 608.71L144.398 531.233Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M189.517 328.375C192.356 331.989 198.101 330.812 199.29 326.373L221.546 243.315C226.09 226.357 222.384 208.25 211.544 194.44L60.8078 2.40816C57.9698 -1.20728 52.2223 -0.0311278 51.0327 4.40849L28.7403 87.6048C24.1941 104.572 27.906 122.689 38.7582 136.501L189.517 328.375Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M206.005 393.448C210.549 376.49 222.811 362.661 239.104 356.122L465.662 265.183C469.928 263.471 474.317 267.364 473.128 271.803L450.835 354.999C446.289 371.966 434.016 385.8 417.711 392.336L191.213 483.125C186.948 484.834 182.561 480.942 183.75 476.504L206.005 393.448Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M167.431 537.407C171.975 520.449 184.238 506.62 200.53 500.081L427.089 409.142C431.354 407.43 435.743 411.322 434.554 415.762L413.736 493.454C409.189 510.425 396.91 524.262 380.6 530.795L154.133 621.505C149.868 623.214 145.482 619.322 146.671 614.884L167.431 537.407Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M244.579 249.489C249.122 232.531 261.385 218.703 277.678 212.163L504.236 121.224C508.501 119.512 512.891 123.405 511.701 127.844L489.409 211.04C484.863 228.007 472.589 241.841 456.285 248.377L229.787 339.166C225.522 340.875 221.135 336.983 222.324 332.545L244.579 249.489Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutBgMobile);
export default __webpack_public_path__ + "static/media/about-bg-mobile.bd802e98322cc456d9f232265de79b7d.svg";
export { ForwardRef as ReactComponent };